// extracted by mini-css-extract-plugin
export default {"fullscreen":"App_fullscreen__LiSvV","btn":"App_btn__GPK0f","flex":"App_flex__alWwv","cantStart":"App_cantStart__Zhmpn"};